import {Component, Inject} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {ObservationDialogData} from '../../../../../../shared/models/observation-group';
import {MatError, MatFormField, MatHint, MatLabel, MatSuffix} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {FormsModule} from '@angular/forms';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatTooltip} from '@angular/material/tooltip';
import {NgxColorsModule} from 'ngx-colors';
import {MatIcon} from '@angular/material/icon';

@Component({
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatError,
    MatHint,
    MatCheckbox,
    MatTooltip,
    MatSuffix,
    MatHint,
    NgxColorsModule,
    MatIcon,
    MatIconButton,
  ],
  selector: 'app-create-observation-group-dialog',
  styleUrls: ['create-observation-group-dialog.component.scss'],
  templateUrl: 'create-observation-group-dialog.component.html'
})
export class CreateObservationGroupDialogComponent {

  defaultMapColor: string;

  constructor(
    public dialogRef: MatDialogRef<CreateObservationGroupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ObservationDialogData,
  ) {
    this.defaultMapColor = data.defaultMapColor;
  }
}
